export default {
  data: function() {
    return {
      exceptions: [
        'number', 'systemid', 'checkbox', 'time', 'checkbox-group', 'radio-group', 'currency', 'text', 'email',
        'password', 'textarea', 'select', 'date', 'number', 'rating', 'address', 'select2',
        'select_case_manager_secondary', 'file', 'image-upload', 'signature', 'programs-checkbox-group',
        'shared-field', 'phone', 'ssn'
      ],
      conditionTypes: [
        {
          type: 'equals',
          name: 'equals'
        },
        {
          type: 'notequal',
          name: 'not equal to'
        },
        {
          type: 'startswith',
          name: 'starts with'
        },
        {
          type: 'contains',
          name: 'contains'
        },
        {
          type: 'notcontain',
          name: 'does not contain'
        },
      ],
      dateConditions: [
        {
          type: 'today',
          name: 'Today'
        },
        {
          type: 'thisweek',
          name: 'This week'
        },
        {
          type: 'thismonth',
          name: 'This month'
        },
        {
          type: 'thisyear',
          name: 'This year'
        },
        {
          type: 'birthmonth',
          name: 'Birth Month'
        },
        {
          type: 'recent',
          name: 'Most recent'
        },
        {
          type: 'lessthan',
          name: 'Less than'
        },
        {
          type: 'greaterthan',
          name: 'Greater than'
        },
        {
          type: 'lessorequal',
          name: 'Less or equal to'
        },
        {
          type: 'greaterorequal',
          name: 'Greater or equal to'
        },
        {
          type: 'between',
          name: 'Between'
        },
        {
          type: 'isempty',
          name: 'Is empty'
        },
        {
          type: 'isfilled',
          name: 'Is filled'
        }
      ],
      numericConditionTypes: [
        {
          type: 'lessthan',
          name: 'less than'
        },
        {
          type: 'greaterthan',
          name: 'greater than'
        },
        {
          type: 'lessorequal',
          name: 'less or equal to'
        },
        {
          type: 'greaterorequal',
          name: 'greater or equal to'
        },
        {
          type: 'between',
          name: 'between'
        },
      ],
      emptyFilledConditionTypes: [
        {
          type: 'isempty',
          name: 'is empty'
        },
        {
          type: 'isfilled',
          name: 'is filled'
        }
      ],
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/reportCommons.js